import { Grid } from '@material-ui/core';
import React from 'react';
import DocumentationStyles from '../sass/partials/_documentation.module.scss'
import NetworkCalls from '../utils/NetworkCalls';

interface State {
  info: string;
}

export default class About extends React.Component<any, State> {

  public state = {
    info: ""
  }

  private abortController = new AbortController();

  private async fetchAboutInfo(): Promise<void> {
    try {
      const res: any = await NetworkCalls.fetchAboutInfo(
        this.abortController);
        this.setState({ info: res.info });
    } catch {}
  }

  public componentDidMount(): void {
    this.fetchAboutInfo();
  }

  public componentWillUnmount(): void {
    this.abortController.abort();
  }

  public render(): React.ReactElement {
    return (
      <Grid container className={DocumentationStyles.grid}>
        <Grid item xs={11} className={DocumentationStyles.gridItemFirst}>
        <div dangerouslySetInnerHTML={{ __html: this.state.info }} />
        </Grid>
      </Grid>
    );
  }
}
